import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { availableReports } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Role } from '../../models/roles';


@IonicPage()
@Component({
  selector: 'page-report-selection',
  templateUrl: 'report-selection.html',
})
export class ReportSelectionPage {

  isAdmin: boolean;
  list;

  constructor(
    public globalVars: GlobalVars,
    public navCtrl: NavController, 
    public navParams: NavParams
  ) {
    this.isAdmin = this.globalVars.user.role == Role['admin'];
    this.list = availableReports.filter(report => this.isAdmin >= report.admin);
  }

  goTo(selectedReport) {
    this.navCtrl.push(selectedReport.page);
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-selection/report-selection.ts